angular.module('tf.services')

    .factory('NotificationService', ['$alert', '$modal', '$uibModal', function($alert, $modal, $uibModal){
        var service = {};


        var path = 'js/components/notifications/';

        var alerts = [];
        var popups = [];
        var modals = [];

        function closeAlerts(){
            _.each(alerts, function(alert){
                alert.hide();
            });
            alerts = [];
        }
        function closePopups(){
            _.each(popups, function(popup){
                popup.hide();
            });
            popups = [];
        }
        function closeModals(){
            _.each(modals, function (modal) {
                modal.close();
            });
            modals = [];
        }
        function closeAll(){
            closeAlerts();
            closeModals();
            closeModals();
        }

        service.modal = function(options, cb){
            var modalInstance = $uibModal.open(options);
            modalInstance.result.then(function(success){
                if(success && cb){
                    cb();
                }
            });
            modals.push(modalInstance);
        };

        service.notify = function(template, params, options){
            closeAlerts();
            options = options || {};
            var alert = $alert({
                templateUrl : path + template + '/' + template + '.html',
                controller  : ['$scope',function($scope){angular.extend($scope, params);}],
                show        : false,
                duration    : options.duration || (options.x? undefined : 5),
                placement   : 'general-alert alert-' + (options.position || 'top-right') + " " + (options.class || ''),
                dismissable : !!options.x
            });
            alert.$promise.then(alert.show);
            alerts.push(alert);
        };
        service.popup = function (template, params, options) {
            closePopups();
            params.closeAll = closeAll;
            options = options || {};
            var modal = $modal({
                templateUrl : path + template + '/' + template + '.html',
                controller  : ['$scope',function($scope){angular.extend($scope, params);}],
                placement : "top",
                show:false,
                animation:  options.animation? options.animation : 'none',
                onShow : function(modal){
                    window.onkeydown = function(e) {
                        var key = e.keyCode ? e.keyCode : e.which;

                        if (key === 27) {
                            window.onkeydown = null;
                            modal.hide();
                            e.stopPropagation(true);
                            e.preventDefault();
                        }
                    };
                },
                backdrop : options.backdrop === false? false : true
            });
            modal.$promise.then(modal.show);
            popups.push(modal);


        };
        service.confirm = function(title, content, onConfirm, noCancel, type){
            service.popup('confirm-general', {title : title, content : content, onConfirm : onConfirm, noCancel: noCancel, type: type});
        };
        service.clear = function(){
            closeAlerts();
            closePopups();
        };

        return service;
    }])

.run(['NotificationService','$timeout',function(NotificationService, $timeout){
        //$timeout(function(){
        //    NotificationService.notify('info-alert', {title: 'Title', content: 'this is the content'})
        //}, 2000);

        //$timeout(function(){
        //    NotificationService.popup('info-popup',{title : 'shareEmailSuccess',content : 'shareEmailSuccess'})
        //}, 2000);

    }])

;
